import { inject } from '@angular/core';
import { type CanActivateFn, Router, type RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter, of, switchMap } from 'rxjs';
import { FlagsmithFlags } from '../../../shared/models/flagsmith-flags.enum';
import { selectFlagsmithFeatureFlagIsEnabled, selectFlagsmithFeatureFlagsLoaded } from '../../../store';

export const maintenanceGuard: CanActivateFn = (_, state: RouterStateSnapshot) => {
  const store = inject(Store);
  const router = inject(Router);

  return store.select(selectFlagsmithFeatureFlagsLoaded).pipe(
    filter((loaded) => loaded),
    switchMap(() => {
      return store.select(selectFlagsmithFeatureFlagIsEnabled(FlagsmithFlags.MaintenanceMode)).pipe(
        switchMap((maintenanceActive) => {
          const isOnMaintenancePage = state.url.includes('maintenance-active');

          if (maintenanceActive && !isOnMaintenancePage) {
            router.navigate(['/maintenance-active'], {
              queryParams: { url: state.url || '/' },
            });
          } else if (!maintenanceActive && isOnMaintenancePage) {
            const params = new URLSearchParams(window.location.search);

            let redirectUrl = params.get('url') || '/';
            if (!redirectUrl.startsWith('/') || /^\/\//.test(redirectUrl) || redirectUrl.includes('://')) {
              redirectUrl = '/';
            }

            router.navigateByUrl(redirectUrl, { skipLocationChange: true });
          }

          return of(true);
        })
      );
    })
  );
};
